import { HomeRulePage } from './HomeRulePage';
export default HomeRulePage;
